import {
  bindService,
  createServiceToken,
  type AppFeatureDefinition,
} from "@nasam/kernel";
import { createProfileHttpRepository } from "./data";
import type { ProfileRepository } from "./domain";
import { createProfileRoutes } from "./presentation/routes";

export const profileRepositoryToken = createServiceToken<ProfileRepository>(
  "profile.profile-repository",
);

/**
 * The signed-in user's own profile. Not a rail icon: its "account" node is
 * opened by the avatar at the foot of the rail, and its two tabs fill the
 * drawer. No permissions -- every signed-in user has one.
 */
export const profileFeature: AppFeatureDefinition = {
  id: "profile",
  version: "0.1.0",
  titleKey: "profile:moduleTitle",
  icon: "User",
  basePath: "/profile",
  requiredPermissions: [],
  navigation: [
    {
      id: "account",
      titleKey: "profile:nav.account",
      icon: "User",
      placement: "account",
      path: "/profile",
      children: [
        {
          id: "profile",
          titleKey: "profile:nav.profile",
          icon: "User",
          placement: "drawer",
          order: 10,
          // Also covers /profile/edit (longest-prefix match).
          path: "/profile",
        },
        {
          id: "profile-security",
          titleKey: "profile:nav.security",
          icon: "ShieldCheck",
          placement: "drawer",
          order: 20,
          path: "/profile/security",
        },
      ],
    },
  ],
  routes: (context) =>
    createProfileRoutes({
      context,
      repository: context.services.resolve(profileRepositoryToken),
    }),
  provideServices: ({ httpClient }) => [
    bindService(
      profileRepositoryToken,
      createProfileHttpRepository(httpClient),
    ),
  ],
};
